var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_c('my-header',[_vm._v(" canvas测试 ")]),_c('canvas',{ref:"output_canvas",staticClass:"output_canvas",attrs:{"width":500,"height":300}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }